import { render, staticRenderFns } from "./coach-reports.vue?vue&type=template&id=4aa1be16&"
import script from "./coach-reports.vue?vue&type=script&lang=js&"
export * from "./coach-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports